import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {FormView} from "../../domain/form-view";
import {Form, FormControl, FormGroup} from "@angular/forms";
import {BehaviorSubject, Observable} from "rxjs";
import {parseTemplate} from "codelyzer/angular/templates/templateParser";



@Component({
    selector: 'app-view-field',
    templateUrl: './view-field.component.html',
    styleUrls: ['./view-field.component.css'],
})
export class ViewFieldComponent implements OnInit {

    @Input('viewModel') viewModel: FormView;
    @Input('form') formGroup: FormGroup;
    document: ViewModelText = new ViewModelText();

    constructor(private cd: ChangeDetectorRef) {
    }

    ngOnInit() {
        let p = new Paragraph(this.document);
        p.blockAlignment = this.viewModel.fields[0].blockAlignment;
        p.alignment = this.viewModel.fields[0].alignment;
        p.blockWidth = this.viewModel.fields[0].blockWidth;
        p.indentate = this.viewModel.fields[0].indentate;
        let shouldIndentate = false;
        for (const f of this.viewModel.fields) {
            f.placeholder.split('<br>').forEach(section => {
                section.replace('{@}', '||{@}||')
                    .split('||')
                    .forEach(s => {
                        if(s.trim().length > 0){
                            if(s === '{@}'){
                                const element = new TextElement(ViewModelText.getNewId(),'campo a completar', p, f.required,true);
                                element.control = this.formGroup.get(f.id+'') as FormControl;
                                p.values.push(element)

                            } else {
                                p.values.push(new TextElement(ViewModelText.getNewId(), s, p, false, false))
                            }
                        }
                    });
                p.indentate = p.indentate || shouldIndentate || f.indentate;
                if (f.linebreak){
                    p.blockWidth = f.blockWidth;
                    p.blockAlignment = f.blockAlignment;
                    p.alignment = f.alignment;
                    if(p.values.length)
                        this.document.paragraphs.push(p);
                    p = new Paragraph(this.document);

                }
            });

            if((shouldIndentate || f.indentate) && !f.linebreak){
                shouldIndentate = true;
            } else {
                shouldIndentate = false;
            }

        }

    }


}

export class ViewModelText {
    paragraphs: Paragraph[] = [];
    private static _id = 0;

    static getNewId(): number {
        this._id++;
        return this._id;
    }

    updateFormValues(){
        const controls: FormControl[] = [];
        let lastWasInput = false;
        this.paragraphs.forEach(p => {
            p.values.filter(v => v.value.trim().length > 0).forEach(v => {
                if(lastWasInput && v.isInput) {
                    controls[controls.length-1].setValue(controls[controls.length-1].value + '<br>' + v.value);
                    lastWasInput = true;
                } else if(v.isInput) {
                    lastWasInput = true;
                    v.control.setValue(v.value.replace(/&nbsp;/g, " "))
                    controls.push(v.control);
                } else {
                    lastWasInput = false;
                }
            })
        });
    }
}

export class Paragraph {
    values: TextElement[] = [];
    focused: TextElement;
    parent: ViewModelText;
    alignment: string;
    blockWidth: number;
    blockAlignment: string;
    indentate: boolean;

    constructor(parent: ViewModelText){
        this.parent = parent;
    }

    get lastChild(){
        return this.values.length > 0 ? this.values[this.values.length-1] : null;
    }
}

export class TextElement {
    id: number;
    value: string;
    isInput: boolean = false;
    parent: Paragraph;
    skiped: boolean = false;
    required: boolean;
    private _control: FormControl;

    constructor(id: number, value: string, parent: Paragraph, required: boolean, isInput: boolean = false) {
        this.value = value;
        this.id = id;
        this.required = required;
        this.parent = parent;
        this.isInput = isInput;
    }


    get control(): FormControl {
        return this._control;
    }

    set control(value: FormControl) {
        this._control = value;
        this.control.valueChanges.subscribe(() => {
            this.skiped = !this.control.enabled;
        })
    }

    onSkippedChange(){
        this.skiped ? this._control.enable() : this._control.disable();
    }

    onFocus(event: FocusEvent){
        if(this.isInput && !this.skiped){
            this.parent.focused = this;
            if(this.value === 'campo a completar'){
                this.value = '';
                this.setCursorAt();
            }
        }
    }

    refreshValue(){
        this.value = document.getElementById(this.id + '').innerHTML;
        this.parent.parent.updateFormValues();
    }

    onEnter(e: KeyboardEvent){
        this.refreshValue();
        const split = this.value.split('<br>');
        //break en el medio:
        if(split[0].trim().length > 0) {

            const indexOfThis = this.parent.values.indexOf(this);
            this.value = split[0];
            const newElement = new TextElement(ViewModelText.getNewId(), split[1], this.parent, this.required, true);
            console.log(this.control);
            newElement.control = this.control;
            const currentParagraphValues = this.parent.values.slice(0, indexOfThis + 1);
            let newParagraphValues: TextElement[];
            if (indexOfThis === this.parent.values.length - 1) {
                newParagraphValues = [newElement];
            } else {
                newParagraphValues = this.parent.values.slice(indexOfThis, this.parent.values.length);
                newParagraphValues[0] = newElement;
            }

            this.parent.values = currentParagraphValues;
            console.log('currentParagraphValues', currentParagraphValues);
            const newParagraph = new Paragraph(this.parent.parent);
            newParagraph.blockWidth = this.parent.blockWidth;
            newParagraph.blockAlignment = this.parent.blockAlignment;
            newParagraph.alignment = this.parent.alignment;
            newParagraph.indentate = this.parent.indentate;
            //newParagraph.
            newElement.parent = newParagraph;
            newParagraph.values = newParagraphValues;
            newParagraphValues.forEach(e => e.parent = newParagraph);
            this.parent.parent.paragraphs.splice(
                this.parent.parent.paragraphs.indexOf(this.parent) + 1, 0, newParagraph);

            requestAnimationFrame(() => {
                document.getElementById(newElement.id + '').focus();
            })

        } else if(split[0].trim().length === 0) {
            this.value = this.value.replace(/<br>/g, "");
            const indexOfThis = this.parent.values.indexOf(this);
            let currentParagraphValues = this.parent.values.slice(0, indexOfThis);
            if(currentParagraphValues.length > 0){
                this.parent.values.splice(0, indexOfThis);
            }

            const p = new Paragraph(this.parent.parent);
            p.blockWidth = this.parent.blockWidth;
            p.blockAlignment = this.parent.blockAlignment;
            p.alignment = this.parent.alignment;
            p.indentate = this.parent.indentate;
            if(indexOfThis === 0) {
                const element = new TextElement(ViewModelText.getNewId(), "\u00A0", p, false, false);
                currentParagraphValues = [element]
            } else {
                const newElement = new TextElement(ViewModelText.getNewId(), '', this.parent, this.required, true);
                currentParagraphValues.push(newElement);
            }
            p.values = currentParagraphValues;
            currentParagraphValues.forEach(x => x.parent = p);
            this.parent.parent.paragraphs.splice(
                this.parent.parent.paragraphs.indexOf(this.parent), 0, p);
            this.setCursorAt();
            setTimeout(() => {
                this.refreshValue();
                this.value = this.value.replace(/<br>/g, "");
                document.getElementById(this.id + '').focus();
            })
         }
    }

    onBackspace(e: KeyboardEvent){
        const caret = this.getCaretPosition();
        const valueBefore = this.value;
        this.refreshValue();
        const valueAfter = this.value;
        const elementIndex = this.parent.values.indexOf(this);
        const indexOfParent = this.parent.parent.paragraphs.indexOf(this.parent);
        let finalCaretPosition = 0;
        //borrado al principio del input al principio del parrafo. El resto no interesa
        if(elementIndex === 0 && indexOfParent > 0 && valueBefore === valueAfter){
            //mergeo los dos parrafos
            const paragraphBefore = this.parent.parent.paragraphs[indexOfParent-1];
            if(paragraphBefore.lastChild != null && (paragraphBefore.lastChild.isInput || paragraphBefore.lastChild.value.trim().length === 0)) {
                paragraphBefore.values.push(...this.parent.values);
                paragraphBefore.values.forEach(e => e.parent = paragraphBefore);
                paragraphBefore.values = paragraphBefore.values.filter(v => v.value.trim().length > 0 || v.equals(this));
                //elimino este parrafo
                this.parent.parent.paragraphs.splice(indexOfParent, 1);
                //ahora hay que mergear los inputs adyacentes...
                let mergedWith: TextElement;
                const values = this.parent.values;
                for (let i = 0; i < values.length-1; i++) {
                    if(values[i].isInput && values[i+1].isInput){

                        if(values[i+1].equals(this)){
                            mergedWith = values[i];
                            finalCaretPosition = values[i].value.length;
                        }
                        values[i].value += values[i+1].value;
                        values.splice(i+1,1);
                    }
                }

                if(mergedWith != null) {
                    mergedWith.setCursorAt(finalCaretPosition);
                } else {
                    this.setCursorAt(0);
                }

            }
        } else {
            setTimeout(() => {
                this.setCursorAt(caret);
            })
        }

    }

    onDelete(e: KeyboardEvent){
        const caret = this.getCaretPosition();
        const valueBefore = this.value;
        this.refreshValue();
        const valueAfter = this.value;
        const indexOfParent = this.parent.parent.paragraphs.indexOf(this.parent);
        //borrado al fin del input al fin del parrafo. El resto no interesa
        if(this.equals(this.parent.lastChild) && indexOfParent < this.parent.parent.paragraphs.length-1
            && valueBefore === valueAfter){
            const nextParagraph = this.parent.parent.paragraphs[indexOfParent+1];
            let finalCaretPosition = this.value.length;
            if(nextParagraph.values[0].isInput || nextParagraph.values[0].isInput){
                this.parent.values.push(...nextParagraph.values);
                this.parent.values.forEach(e => e.parent = this.parent);
                this.parent.values = this.parent.values.filter(v => v.value.trim().length > 0);

                //elimino el parrafo siguiente
                this.parent.parent.paragraphs.splice(indexOfParent+1, 1);
                //ahora hay que mergear los inputs adyacentes...
                const values = this.parent.values;
                for (let i = 0; i < values.length-1; i++) {
                    if(values[i].isInput && values[i+1].isInput){
                        values[i].value += values[i+1].value;
                        values.splice(i+1,1);
                    }
                }

                this.setCursorAt(finalCaretPosition);


            }
        } else {
            this.setCursorAt(caret);
        }
    }

    equals(o: TextElement): boolean {
        return this.id === o.id;
    }

    removeFromParent(){
        const i = this.parent.values.indexOf(this);
        this.parent.values.splice(i, 1);
    }

    setCursorAt(position: number = this.value.length) {
        setTimeout(() => {
            const el = document.getElementById(this.id + '');
            const range = document.createRange();
            const sel = window.getSelection();
            let node = el.childNodes[el.childNodes.length - 1];
            if(node == undefined){
                node = el;
            }
            range.setStart(node, position);
            range.setEnd(node, position);
            range.collapse(true);
            sel.removeAllRanges();
            sel.addRange(range);
        });
    }

    getCaretPosition() {
        let _range = document.getSelection().getRangeAt(0);
        let range = _range.cloneRange();
        range.selectNodeContents(document.getElementById(this.id + ''));
        range.setEnd(_range.endContainer, _range.endOffset);
        return range.toString().length;
    }

    onPaste(event: ClipboardEvent) {
        event.preventDefault();
        const text = event.clipboardData.getData("text/plain");
        document.execCommand("insertHTML", false, text);

    }

    get previusInputHasSameControl(): boolean {
        const indexOfThis = this.parent.values.indexOf(this);
        if(indexOfThis === 0){
            const indexOfParent = this.parent.parent.paragraphs.indexOf(this.parent);
            if(indexOfParent > 0){
                const paragraphBefore = this.parent.parent.paragraphs[indexOfParent-1];
                return paragraphBefore.lastChild.control === this.control;
            } else {
                return false;
            }
        } else {
            return this.parent.values[indexOfThis-1].control === this.control;
        }
    }


}





// WEBPACK FOOTER //
// ./src/app/form-views/components/view-field/view-field.component.ts